import React from 'react';

import { TEXT_WEIGHT } from '../../constants';
import { H3 } from '../../header-text/header-text';

import './lesson-banner-view__header.scss';

interface Props {
    text: string;
}

export const LessonBannerViewHeader = React.memo(({ text }: Props) => {
    return (
        <div className="lesson-banner-view__header">
            <H3 weight={TEXT_WEIGHT.M}>{text}</H3>
        </div>
    );
});
